import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import i18n, { getStartingLocale } from './i18n'
import { supportedLocalesInclude } from './util/i18n/supported-locales'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  let language = to.params.lang;
  // Links without a language prefix (e.g. /kontakt) get the visitor's language
  if (language && !supportedLocalesInclude(language)) {
    return next(`/${getStartingLocale()}${to.fullPath}`)
  }
  if (!language) {
    language = getStartingLocale()
  }

  i18n.locale = language
  next()
})

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
